import { DisplayAuthoringPropertyPipe, InheritPipe, IsRequiredPropertyPipe } from '@adaptiva/metadata/common';
import { CardComponentModule } from '@adaptiva/widgets/card';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { ObjectListModule } from '@adaptiva/widgets/object-list';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { CommonModule } from '@angular/common';
import { NgModule, PipeTransform, Type } from '@angular/core';
import { AuthoringPropertyLabelComponentModule } from '../authoring-property-label-component';
import { ProductPropertiesComponent } from './product-properties.component';

const PIPES: Type<PipeTransform>[] = [
	DisplayAuthoringPropertyPipe,
	InheritPipe,
	IsRequiredPropertyPipe,
];

const WIDGETS: Type<NgModule>[] = [
	AuthoringPropertyLabelComponentModule,
	CardComponentModule,
	ContainerComponentModule,
	ObjectListModule,
	TextComponentModule,
];

@NgModule({
	imports: [
		CommonModule,
		PIPES,
		WIDGETS,
	],
	declarations: [ProductPropertiesComponent],
	exports: [ProductPropertiesComponent]
})
export class ProductPropertiesComponentModule {

}
